import React from "react";
import TitoloColore from "../commons/TitoloColore";
import ScrollToTopOnMount from "../components/ScrollToTopOnMount";
import calendario from "../images/Calendario_2023_2024.jpg"
import Space from "../commons/Space";
import TitoloSezioni from "../commons/TitoloSezioni";
import SpaceL from "../commons/SpaceL";
import fin from "../images/logo/Fin.svg";
import uisp from "../images/logo/Logo_UISP.png";
import libertas from "../images/logo/libertas.jpeg";


function Calendario() {
    return(
        <div>
            <ScrollToTopOnMount />
            <TitoloColore title={"Calendario"} backgroundColor={"#003F83"} />
            <div className="text-center d-flex flex-column align-items-center">
                <div className="d-none d-sm-block"><Space /></div>
                <div className="d-block d-sm-none"><SpaceL /></div>
                <h1 className="text-center" style={{fontFamily: "Hammersmith One", padding: "1em"}}>Calendario attività</h1>
                <figure className="text-center">
                    <blockquote className="blockquote">
                        Il centro rimarrà chiuso da
                        <br/>
                        <strong>domenica 28 luglio</strong>
                        <br/>
                        a
                        <br/>
                        <strong>mercoledì 28 agosto</strong>
                        <br/>
                        compresi
                        <br/>
                        <br/>
                        Riapertura giovedì 29 agosto con orario normale 9 - 22
                    </blockquote>
                </figure>
                <div style={{display: "flex", flexDirection: "column", width: "60%"}}>
                <a style={{alignSelf: "end"}} href={calendario} download>
                    <i style={{fontSize: "2em", color: "grey", marginRight: "0.5em"}} className="bi bi-download"></i>
                </a>
                <img src={calendario} style={{width: "80%", margin: "auto"}}></img>
                </div>
            </div>
            <Space />
        </div>
    )
}

export default Calendario